import axios from "axios";

export default {
  async getReferentAutreTypeByUid(typeReferent, uid) {
    const response = await axios.get(
      process.env.VUE_APP_BACKEND_API_URL +
        "/api/gestion/" +
        typeReferent +
        "/autresReferents/" +
        uid
    );
    return response.data;
  },
  async getReferentsSuaio() {
    const response = await axios.get(
      process.env.VUE_APP_BACKEND_API_URL + "/api/gestion/referentsSuaio"
    );
    return response.data;
  },
  async notifierPresence(idEtudiant) {
    const response = await axios.post(
      process.env.VUE_APP_BACKEND_API_URL +
        "/api/suaio/etudiants/presence/" +
        idEtudiant
    );
    return response.data;
  },
  async notifierAtelier(idEtudiant) {
    const response = await axios.post(
      process.env.VUE_APP_BACKEND_API_URL +
        "/api/suaio/etudiants/atelier/" +
        idEtudiant
    );
    return response.data;
  }
};
